export const POST_QUESTION_REQUEST = 'POST_QUESTION_REQUEST'
export const POST_QUESTION_SUCCESS = 'POST_QUESTION_SUCCESS'
export const POST_QUESTION_FAIL = 'POST_QUESTION_FAIL'
export const POST_QUESTION_RESET = 'POST_QUESTION_RESET'

export const FETCH_USER_QUESTIONS_REQUEST = 'FETCH_USER_QUESTIONS_REQUEST'
export const FETCH_USER_QUESTIONS_SUCCESS = 'FETCH_USER_QUESTIONS_SUCCESS'
export const FETCH_USER_QUESTIONS_FAIL = 'FETCH_USER_QUESTIONS_FAIL'

export const FETCH_VOLUNTEER_QUESTION_REQUEST = 'FETCH_VOLUNTEER_QUESTION_REQUEST'
export const FETCH_VOLUNTEER_QUESTION_SUCCESS = 'FETCH_VOLUNTEER_QUESTION_SUCCESS'
export const FETCH_VOLUNTEER_QUESTION_FAIL = 'FETCH_VOLUNTEER_QUESTION_FAIL'

export const FETCH_USER_QUESTION_BY_ID_REQUEST = 'FETCH_USER_QUESTION_BY_ID_REQUEST'
export const FETCH_USER_QUESTION_BY_ID_SUCCESS = 'FETCH_USER_QUESTION_BY_ID_SUCCESS'
export const FETCH_USER_QUESTION_BY_ID_FAIL = 'FETCH_USER_QUESTION_BY_ID_FAIL'

export const FETCH_VOLUNTEER_CHAT_BY_ID_REQUEST = 'FETCH_VOLUNTEER_CHAT_BY_ID_REQUEST'
export const FETCH_VOLUNTEER_CHAT_BY_ID_SUCCESS = 'FETCH_VOLUNTEER_CHAT_BY_ID_SUCCESS'
export const FETCH_VOLUNTEER_CHAT_BY_ID_FAIL = 'FETCH_VOLUNTEER_CHAT_BY_ID_FAIL'
export const FETCH_VOLUNTEER_CHAT_BY_ID_RESET = 'FETCH_VOLUNTEER_CHAT_BY_ID_RESET'

export const FETCH_VOLUNTEER_QUESTION_BY_ID_REQUEST = 'FETCH_VOLUNTEER_QUESTION_BY_ID_REQUEST'
export const FETCH_VOLUNTEER_QUESTION_BY_ID_SUCCESS = 'FETCH_VOLUNTEER_QUESTION_BY_ID_SUCCESS'
export const FETCH_VOLUNTEER_QUESTION_BY_ID_FAIL = 'FETCH_VOLUNTEER_QUESTION_BY_ID_FAIL'

export const FETCH_ACTIVE_QUESTIONS_REQUEST = 'FETCH_ACTIVE_QUESTIONS_REQUEST'
export const FETCH_ACTIVE_QUESTIONS_SUCCESS = 'FETCH_ACTIVE_QUESTIONS_SUCCESS'
export const FETCH_ACTIVE_QUESTIONS_FAIL = 'FETCH_ACTIVE_QUESTIONS_FAIL'

export const FETCH_PICKED_QUESTIONS_REQUEST = 'FETCH_PICKED_QUESTIONS_REQUEST'
export const FETCH_PICKED_QUESTIONS_SUCCESS = 'FETCH_PICKED_QUESTIONS_SUCCESS'
export const FETCH_PICKED_QUESTIONS_FAIL = 'FETCH_PICKED_QUESTIONS_FAIL'

export const FETCH_REPLIED_QUESTIONS_REQUEST = 'FETCH_REPLIED_QUESTIONS_REQUEST'
export const FETCH_REPLIED_QUESTIONS_SUCCESS = 'FETCH_REPLIED_QUESTIONS_SUCCESS'
export const FETCH_REPLIED_QUESTIONS_FAIL = 'FETCH_REPLIED_QUESTIONS_FAIL'

export const REPLY_QUESTION_REQUEST = 'REPLY_QUESTION_REQUEST'
export const REPLY_QUESTION_SUCCESS = 'REPLY_QUESTION_SUCCESS'
export const REPLY_QUESTION_FAIL = 'REPLY_QUESTION_FAIL'
export const REPLY_QUESTION_RESET = 'REPLY_QUESTION_RESET'

export const UPDATE_QUESTION_STATUS_REQUEST = 'UPDATE_QUESTION_STATUS_REQUEST'
export const UPDATE_QUESTION_STATUS_SUCCESS = 'UPDATE_QUESTION_STATUS_SUCCESS'
export const UPDATE_QUESTION_STATUS_FAIL = 'UPDATE_QUESTION_STATUS_FAIL'
export const UPDATE_QUESTION_STATUS_RESET = 'UPDATE_QUESTION_STATUS_RESET'

export const UPDATE_RATING_REQUEST = 'UPDATE_RATING_REQUEST'
export const UPDATE_RATING_SUCCESS = 'UPDATE_RATING_SUCCESS'
export const UPDATE_RATING_FAIL = 'UPDATE_RATING_FAIL'
export const UPDATE_RATING_RESET = 'UPDATE_RATING_RESET'